import React, { useState } from "react";
import { Table, Row, Col, Tooltip, Typography } from "antd";
import moment from 'moment';
import { FullHeightContainerLayout } from "components";
import _ from 'lodash';
import ApiKeyChangedAttributes from "components/molecules/ApiKeyChangedAttributes";
import SystemKeysChnagedAttributes from "components/molecules/SystemKeysChnagedAttributes";
import CypressTestIds from "../../../cypress/CypressTestIds";

const { Column } = Table;
const { Link } = Typography;

const KeyHistoryList = ({ systemKeyRevisions }) => {
    const [recordDetail, setRecordDetail] = useState(null);
    // console.log("record detail", recordDetail);
    const [containerHeight, setContainerHeight] = useState("100%");
    return (
        <Row style={{ flexDirection: "column", flexGrow: 1, height: "100%" }}>
            <Col span={24} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                <Row style={{ flexDirection: "column", flexGrow: 1, height: containerHeight }}>
                    <Col span={24}>
                        <FullHeightContainerLayout
                            content={<Table size="small"
                                rowKey="data.version"
                                dataSource={systemKeyRevisions}
                                pagination={false}
                                scroll={{ y: `100vh` }}
                                className={"container-height-100"}
                                data-testid={CypressTestIds.COMMON_OBJECTS_REVISIONS_LIST_TABLE}>
                                <Column
                                    width="3rem"
                                    title="No."
                                    key="index"
                                    render={(value, item, index) => index + 1}
                                />
                                <Column
                                    width="10rem"
                                    dataIndex={["data", "name"]}
                                    title={"Key Name"}
                                    render={(value, revision, index) => <>{value}</>}
                                />
                                <Column
                                    width="12rem"
                                    dataIndex={["data", "description"]}
                                    title={"Description"}
                                    ellipsis={{
                                        showTitle: false,
                                    }}
                                    render={(value, revision, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                                />
                                <Column
                                    width="10rem"
                                    dataIndex={["data", "type"]}
                                    title={"Type"}
                                    render={(value, revision, index) => <>{value}</>}
                                />
                                <Column
                                    width="12rem"
                                    dataIndex={["data", "createdBy"]}
                                    title={"Created By"}
                                    ellipsis={{
                                        showTitle: false,
                                    }}
                                    render={(value, revision, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                                />
                                <Column
                                    width="12rem"
                                    dataIndex={["data", "createdDate"]}
                                    title={"Created Date"}
                                    render={(value, revision, index) => <>{moment.utc(value).toDate().toLocaleString()}</>}
                                />
                                <Column
                                    width="12rem"
                                    dataIndex={["data", "updatedBy"]}
                                    title={"Updated By"}
                                    ellipsis={{
                                        showTitle: false,
                                    }}
                                    render={(value, revision, index) => <Tooltip placement="topLeft" title={value}>{value}</Tooltip>}
                                />
                                <Column
                                    width="12rem"
                                    dataIndex={["data", "updatedDate"]}
                                    title={"Updated Date"}
                                    render={(value, revision, index) => <>{moment.utc(value).toDate().toLocaleString()}</>}
                                />
                                <Column
                                    width="12rem"
                                    dataIndex={"changes"}
                                    title={"Changes"}
                                    render={(value, revision, index) => {
                                        if (value) {
                                            return <>
                                                {Object.keys(value).reduce((items, key) => {
                                                    if (Object.keys(value[key]).length > 0) {
                                                        items.push(<Row key={key}>
                                                            <Col>
                                                                <Link onClick={() => {
                                                                    setContainerHeight("50%");
                                                                    setRecordDetail({
                                                                        name: `${_.capitalize(key)} attributes`,
                                                                        recordId: revision.data.keyId,
                                                                        data: value[key],
                                                                        previousData: revision.previousChanges && revision.previousChanges[key]
                                                                    });
                                                                }}>
                                                                    {`${key} attributes`}
                                                                </Link>
                                                            </Col>
                                                        </Row>);
                                                    }
                                                    return items;
                                                }, [])}
                                            </>
                                        }
                                        return <></>;
                                    }}
                                />
                            </Table>}>
                        </FullHeightContainerLayout>
                    </Col>
                </Row>
                {
                    recordDetail
                        ? (
                            <Row style={{ flexDirection: "column", flexGrow: 1, height: containerHeight }}>
                                <Col span={24}>
                                    <FullHeightContainerLayout
                                        showHeader={false}
                                        content={<SystemKeysChnagedAttributes key={recordDetail.recordId} record={recordDetail}></SystemKeysChnagedAttributes>} // Placeholder for detailed view
                                        showFooter={false}>
                                    </FullHeightContainerLayout>
                                </Col>
                            </Row>
                        )
                        : null
                }
            </Col>
        </Row>
    );
};

export default KeyHistoryList;
